import Vue   from 'vue'
import Vuex  from 'vuex'
import Axios from 'axios'
import { ENVIRONMENT }      from './config'
import { CONCERN_FHIR_IDs } from './config'
// import { MAR_URLs } from './config'

Vue.use(Vuex)
Vue.config.devtools = true;

export default new Vuex.Store({
  
  state: {
    APPREADY: undefined,
    context: {},
    patientData: {},
    currentDtm: new Date(),
    observationData: [],
    concernScoresData: [],
    documents: [],
    rawPatientData: {},
    medications: [],
    console: { value: '' },
  },

  getters: {

    concernIsZero: state => {
      return ( ( state.concernScoresData.length === 0 ) || (
        state.concernScoresData
        && state.concernScoresData[0]
        && state.concernScoresData[0].value
        && ( state.concernScoresData[0].value.concern_score == 0 )
      ));
    },

    loggingContext: state => ({
      ...state.context
    }),

    currentDtm: state => state.currentDtm,

    APPREADY: state => state.APPREADY,

    patientData: state => state.patientData || {},

    rawPatientData: state => state.rawPatientData || {},

    consoleData: state => state.console.value || '',

    location: state => {
      return state.concernScoresData && state.concernScoresData[0] && state.concernScoresData[0].value
          && ( state.concernScoresData[0].value.department_name + ' ' + state.concernScoresData[0].value.roomandbedname )
          || '';
    },

    demographics: state => ({
      firstName: state.patientData.firstName,
      lastName: state.patientData.lastName,
      mrn: state.patientData.mrn || '',
      location: state.patientData.location,
      birthdateISO: state.patientData.dob,
    }),

    concernData: ( state ) => state.concernScoresData,

    concernPatientData: state => state.patientData.encounter && state.patientData.encounter[0].ConcernData || [],

    documents: state => state.documents,

    vitals: state => state.observationData,

    medications: ( state ) => {

      const marData = state.concernScoresData[0]
                    && state.concernScoresData[0].value.mar
                    && JSON.parse( state.concernScoresData[0].value.mar )
                    || [];

      return marData;
    },

    concernNoteData: ( state ) => {

      //  strip links
      const anchorRegex = /<a[\s]+([^>]+)>((?:.(?!<\/a>))*.)<\/a>/g;

      const notes = state.patientData.encounter && state.patientData.encounter[0].ConcernNoteMeta || [];
      return notes.map( n => ({
        ...n,
        Element: 'factor_note_content',
        Sub_element: 'value',
        Is_active: n.ActiveNoteContent[0].is_active,
        //  strip links
        Value: n.ActiveNoteContent[0].content && n.ActiveNoteContent[0].content.replace( anchorRegex, '' ) || '',
      }));
    },

    greenYellowCutoff: ( state, getters ) => {
      const d = getters.concernData;
      const cutoff = d && d[0] && d[0].value && d[0].value.green_yellow_threshold || 0;
      return cutoff && ( parseFloat( cutoff, 10 ) * 100.0 ) || 0;
    },

    yellowRedCutoff: ( state, getters ) => {
      const d = getters.concernData;
      const cutoff = d && d[0] && d[0].value && d[0].value.yellow_red_threshold || 0;
      return cutoff && ( parseFloat( cutoff, 10 ) * 100.0 ) || 0;
    },

    patientPercentile: ( state, getters ) => {
      const d = getters.concernData;
      const cutoff = d && d[0] && d[0].value && d[0].value.patient_percentile || 0;
      return cutoff && ( Math.floor( parseFloat( cutoff, 10 ) * 100.0 ) ) || 0;
    },
  },

  mutations: {

    SET_APPREADY: ( state ) => {
      state.APPREADY = true;
    },

    SET_CONTEXT: ( state, d ) => {
      state.context = d;
    },

    SET_DOCUMENTS: ( state, d ) => {
      state.documents = d;
    },

    SET_PATIENT_DATA: ( state, d ) => {

      let patientData = {};

      state.rawPatientData = d;

      const name = d.name.find( e => e.use === 'official' ) || {};

      if ( name ) {
        patientData.firstName = name.given.join( ' ' );
        patientData.lastName = name.family;
      }


      const mrn = d.identifier.find( id => (
        ( id.system === 'urn:oid:1.2.5.8.2.7' ) ||
        ( id.system === 'urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.14' )
      )) || {};

      patientData.mrn = mrn && mrn.value || '';

      patientData.dob = d.birthDate;

      patientData.fhirID = d.id;

      patientData.location = d.locationName;

      state.patientData = patientData;
    },

    SET_CONCERN_SCORES_DATA: ( state, data ) => {

      if ( !data ) { return }

      let decodedData = data.map( d => {
        return {
          value: JSON.parse( atob( d.resource.valueString) ),
          dtm: d.resource.effectiveDateTime,
        }
      })
      //  reverse chronological sort
      .sort( ( a, b ) => { return ( a.dtm < b.dtm ) ? 1 : -1; });

      state.concernScoresData = decodedData;
    },

    SET_CONSOLE_DATA: ( state, d ) => {
      state.console.value = state.console.value + '<br /><br />' + JSON.stringify(d);
    },

    SET_MEDICATION_DATA: ( state, data ) => {

      if ( !data ) { return }

      state.medications.value = data;
    },

    SET_VITALS_DATA: ( state, data ) => {

      if ( !data ) { return }

      let mappedData = data.map( d => {

        let name = d.resource.code.text;
        let comment = d.resource.note && d.resource.note[0].text || '';

        let value = '';
        let uom = '';

        if ( d.resource.valueQuantity ) {

          value = d.resource.valueQuantity.value || '';
          uom = d.resource.valueQuantity.unit ||'';

        //  blood pressure
        } else if ( d.resource.component ) {

          let systolic = d.resource.component.find( c => ( c.code.text && c.code.text.toLowerCase().indexOf( 'systolic' ) === 0 ) );
          let diastolic = d.resource.component.find( c => ( c.code.text && c.code.text.toLowerCase().indexOf( 'diastolic' ) === 0 ) );
          uom = 'mmHg';

          if ( systolic && diastolic ) {
            value = `${systolic.valueQuantity.value}/${diastolic.valueQuantity.value}`;
          }
        }

        // if ( mapEntry ) {
          return {
            name,
            comment,
            displayName: name,
            value,
            uom,
            dtm: d.resource.effectiveDateTime,
          }
        // }
      });

      mappedData.sort( ( a, b ) => { return ( a.dtm < b.dtm ) ? 1 : -1; });

      state.observationData = mappedData;
    },

  },

  actions: {

    getPatientData: async ( context ) => {

      const concernFhirID = CONCERN_FHIR_IDs[ ENVIRONMENT ] || '';
      const FHIR_ID_BASE = 'http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id';
      
      // const marURL = MAR_URLs[ ENVIRONMENT ] || '';

      //  get date cutoff for lookback
      const LOOKBACK_DAYS = 3;
      let d = new Date();
      d.setDate( d.getDate() - LOOKBACK_DAYS );
      const startDtmISO = d.toISOString().substring(0, 16) + 'Z';
      const DATE_FILTER = `&date=ge${startDtmISO}`;

      //  *** GET CONCERN SCORES LOCALLY
      // let { data } = await Axios.get( 'concernScores.json' );
      // context.commit( 'SET_CONCERN_SCORES_DATA', data && data.entry || [] );

      let accessToken = '';
      let documents = [];

      // eslint-disable-next-line no-undef
      FHIR.oauth2.ready()
        .then( client => {

          //  app isn't ready unless launched from Epic (which is true if we're here)
          context.commit( 'SET_APPREADY' );

          const patientFhirID = client.patient.id;
          const userFhirID = client.user.id;
          const encounterFhirID = client.encounter.id;
          const locationFhirID = client.state.tokenResponse.location;
          const serverURL = client.state.serverUrl;
          accessToken = client.state.tokenResponse.access_token;

          // let mrn = null;

          context.commit( 'SET_CONTEXT', {
            patientFhirID,
            userFhirID,
            encounterFhirID,
            locationFhirID,
            accessToken,
            serverURL
          });

          //  patient demographics
          client.patient.read()
            .then( pt => {
              context.commit( 'SET_PATIENT_DATA', pt );    
            });

          //  *** GET CONCERN SCORES VIA FHIR
          //  CONCERN scores and metadata
          client.patient.request( `Observation?patient=${ client.patient.id }&code=${ FHIR_ID_BASE }|${ concernFhirID }${ DATE_FILTER }`, {} )
            .then( function(data) {
              context.commit( 'SET_CONCERN_SCORES_DATA', data && data.entry || [] );

            }, function (error) {
              // eslint-disable-next-line no-console
              console.log( 'observations error', error );
              // context.commit( 'SET_CONSOLE_DATA', error );
            });

          //  vitals
          client.patient.request( `Observation?patient=${ client.patient.id }&category=vital-signs${ DATE_FILTER }`, {} )
            .then( observations => {
              context.commit( 'SET_VITALS_DATA', observations.entry );
            });


          //  documents
          client.patient.request( `DocumentReference?patient=${ client.patient.id }&category=clinical-note${ DATE_FILTER }`, {} )
            .then( async data => {
              // context.commit( 'SET_CONSOLE_DATA', data );
              documents = data.entry
                .filter( d => ( d.resource && d.resource.resourceType && d.resource.resourceType === 'DocumentReference' ) )
                .map( d => {

                  const url = d.resource && d.resource.content[0] && d.resource.content[0].attachment && d.resource.content[0].attachment.url;

                  return {
                    name: d.resource.type.text || '',
                    author: d.resource.author[0] && d.resource.author[0].display || '',
                    dtm: d.resource.date,
                    url,
                    authorUrl: d.resource.author[0] && d.resource.author[0].reference
                  };
                })
                .filter( d => {
                  return (
                    ( d.author.slice( -4 ) === ', RN' ) &&
                    ( [ 'note', 'nurse note', 'procedure note', 'progress note' ].indexOf( d.name.toLowerCase() ) >= 0 )
                  );
                });

              // context.commit( 'SET_CONSOLE_DATA', documents );
              let docsWithContents = await Promise.all(
                documents.map( async (d) => {

                  let documentData = await Axios.get( `${ serverURL }/${ d.url }`, { headers: { Authorization: `Bearer ${accessToken}` } });
                  // let authorData = await Axios.get( `${ serverURL }/${ d.authorUrl }`, { headers: { Authorization: `Bearer ${accessToken}` } });
                  
                  return {
                    ...d,
                    content: documentData && documentData.data || {},
                    // authorInfo: authorData && authorData.data || {},
                  }
                })
               );
              // context.commit( 'SET_CONSOLE_DATA', docsWithContents );
              context.commit( 'SET_DOCUMENTS', docsWithContents );
            }
          );
  
        });   // end client in context

    },  // end getPatientData()
  }
})
